/* eslint-disable unused-imports/no-unused-vars */
import React, { useCallback, useEffect, useMemo, useRef, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  courtWeekday,
  formatCourtDate,
  formatCourtTime,
  getActEndpoint,
  getActTime,
} from "@/Utils/litigationDates.mjs";
import fileNumberIcon from "@/assets/filenumber.svg";
import ClientDocumentRow from "@/Components/DocumentRow/ClientDocumentRow";

import usePageAttachmentTabs from "../Hooks/usePageAttachmentTabs";
import { useAccessValidation } from "../Providers/ProtectedRoute";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import Footer from "../Components/common/footer";
import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import {
  addClickRecord,
  calculateAge,
  fetchPageObject,
  fetchShakespeareStatus,
  formatCalendarDate,
  formatDateAtTime,
  getCaseId,
  getClientId,
  setCaseId,
  setClientId,
} from "../Utils/helper";
import { setCaseSummary, setCurrentCase } from "../Redux/caseData/caseDataSlice";
import { api_without_cancellation } from "../api/api";
import useCoCounsel from "../Components/CaseDashboard/CoCounsel/useCoCounsel";
import CoCounselFirmRow from "../Components/CaseDashboard/CoCounsel/CoCounselFirmRow";
import incidentIcon from "../assets/images/incident.svg";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import { WorkersOnCase } from "../Components/CaseDashboard/CaseWorkes";
import NewCasePanels from "../Components/CaseDashboard/newCasePage/new-case-page-panel";
import AddNewClientModal from "../Components/Modals/addNewClientModal";
// import ContactPanelForTreatment from "../Components/TreatmentPage/components/ContactPanelForTreatment";
import ChangeOfficeFirmLocationModal from "../Components/Modals/ChangeFirmOfficeModal2";
import CounsellingModal from "../Components/Modals/counsellingModal";
import DefaultThumbnail from "../Components/common/defaultPhotoSlot";
import EditCaseTypeDateModal from "../Components/EditCaseTypeDateModal";
// import ResponsiveTabThreeItems from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabThreeItems";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import CasePageContactPanel from "../Components/common/CasePageContactPanel";
import { useDocumentModal } from "../Components/common/CustomModal/CustomModalContext";
import EditSOLPopup from "../Components/LitigationDashboard/Modals/EditSOLPopup";
import SOLActPopupCasePage from "../Components/CaseDashboard/modals/SOLActPopupCasePage";
import { ClientDataContext } from "../Components/ClientDashboard/shared/DataContext";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import { useTelephonySettings } from "../Hooks/useGetTelephonySettings";
import SOLicon from "../assets/litigation/sol.svg";
import ExpertDiscovery from "../assets/litigation/expert_discovery.svg";
import { setClientProviders } from "../Redux/client-providers/clientProviderSlice";

import avatarImage from "./../assets/images/avatar.svg";

const EVENT_TYPE_ICONS = {
  Filing: "ic-Filing",
  Hearing: "ic-Hearing",
  Motion: "ic-Motion",
  Discovery: "ic-discovery",
  Deposition: "ic-Deposition",
  Exam: "ic-Exam",
  Trial: "ic-Trial",
  Deadline: "ic-Deadline",
  Event: "ic-Event",
  Subpoenas: "ic-Event",
  "Expert Discovery": "ic-discovery",
  "Case Initiation": "ic-Case-Initiation",
  "Mediation / Arbitration": "ic-Mediation-Arbitration",
  "Settlement Conference": "ic-Settlement-Conference",
  Answer: "ic-Answer",
};

const DATE_FORMAT_OPTIONS = {
  month: "short",
  day: "2-digit",
  year: "numeric",
  timeZone: "UTC",
};
const PHOTO_ICON_URL =
  "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg";

const STYLES = {
  incidentIcon: { width: "15px", height: "15px" },
  labelText: { fontSize: "14px", color: "var(--primary-25)" },
};

const formatDateWithAbbreviation = (dateString) => {
  if (!dateString) return null;

  return new Date(dateString)
    .toLocaleDateString("en-US", DATE_FORMAT_OPTIONS)
    .replace(/(\w+)\s(\d+),/, "$1. $2,");
};

const renderStatusLabel = (status = "OPEN", secondaryText = "Intake", dateClosed = null) => (
  <>
    <span className={`${dateClosed ? "color-grey-2" : "color-green"}`}>{status}</span> /{" "}
    {secondaryText}
  </>
);

const imageStyles = {
  maxHeight: "155px",
  maxWidth: "255px",
  width: "auto",
  height: "auto",
  objectFit: "contain",
};

const defaultThumbnailProps = {
  height: "155px",
  width: "255px",
  borderColor: "var(--primary-15)",
};

// why here brother?
export const PhotoSlot = ({
  photoSlot,
  photoSlots,
  pageName = "",
  isPanel = false,
  panelId,
  slotNumber,
  height = "155",
  width = "255",
  refetch = () => {},
}) => {
  const [hasMismatch, setHasMismatch] = useState(false);
  const { showDocumentModal } = useDocumentModal();

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    const imgRatio = naturalWidth / naturalHeight;
    const containerRatio = 255 / 155;
    setHasMismatch(Math.abs(imgRatio - containerRatio) > 0.01);
  };
  const results = { results: [photoSlot] };
  const renderImage = () => {
    if (photoSlot?.image) {
      return (
        <div
          style={{
            height: `${height}px`,
            width: `${width}px`,
            position: "relative",
            overflow: "hidden",
            // border: "10px solid var(--primary-20)",
          }}
        >
          <div
            style={{
              height: `${height}px`,
              width: `${width}px`,
              position: "relative",
              overflow: "hidden",
              border: "10px solid var(--primary-20)",
            }}
          >
            {/* SVG behind, placeholder graphic stretched to fill */}
            <svg
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
              width="109px"
              height={"5rem"}
              viewBox="10 2 4 22"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <g>
                  <path
                    d="M8,13L12,18L10,18L9,17L8,18L7,17L6,18L4,18L8,13Z"
                    style={{
                      fill: "var(--primary-10)",
                      fillRule: "nonzero",
                    }}
                  />
                  <path
                    d="M1,20L8,13L15,20"
                    style={{
                      fill: "none",
                      stroke: "var(--primary-15)",
                      strokeWidth: "2px",
                    }}
                  />
                  <path
                    d="M23,20L19,16L12,23"
                    style={{
                      fill: "none",
                      stroke: "var(--primary-15)",
                      strokeWidth: "2px",
                    }}
                  />
                  <path
                    d="M8.508,5C7.729,5 7.132,5.482 6.762,6.109C5.99,5.876 5.296,6.344 5.113,7.16C4.499,7.348 4,7.828 4,8.5C4,9.323 4.677,10 5.5,10L10.5,10C11.323,10 12,9.323 12,8.5C12,7.718 11.371,7.105 10.604,7.043C10.55,5.918 9.645,5 8.508,5Z"
                    style={{
                      fill: "var(--primary-10)",
                      fillRule: "nonzero",
                    }}
                  />
                  <path
                    d="M17.212,5.339C17.114,5.183 16.886,5.183 16.788,5.339L16.282,6.149C16.274,6.162 16.261,6.172 16.245,6.177C16.23,6.182 16.213,6.181 16.198,6.173L15.353,5.724C15.19,5.637 14.993,5.751 14.986,5.936L14.953,6.87C14.952,6.892 14.943,6.913 14.928,6.928C14.913,6.943 14.892,6.952 14.87,6.953L13.936,6.986C13.751,6.992 13.637,7.19 13.724,7.353L14.173,8.199C14.181,8.213 14.182,8.229 14.177,8.245C14.172,8.26 14.162,8.274 14.149,8.282L13.339,8.788C13.183,8.886 13.183,9.114 13.339,9.212L14.149,9.718C14.163,9.726 14.172,9.74 14.177,9.755C14.182,9.77 14.181,9.787 14.173,9.802L13.724,10.647C13.637,10.81 13.751,11.008 13.936,11.014L14.87,11.047C14.892,11.048 14.913,11.057 14.928,11.072C14.943,11.087 14.952,11.108 14.953,11.13L14.986,12.064C14.993,12.249 15.19,12.363 15.353,12.276L16.198,11.827C16.213,11.819 16.23,11.818 16.245,11.823C16.261,11.828 16.274,11.838 16.282,11.851L16.788,12.661C16.886,12.817 17.114,12.817 17.212,12.661L17.717,11.852C17.726,11.838 17.74,11.828 17.756,11.822C17.77,11.817 17.787,11.819 17.801,11.827L18.647,12.276C18.81,12.363 19.008,12.249 19.014,12.064L19.047,11.13C19.048,11.108 19.057,11.087 19.072,11.072C19.087,11.057 19.108,11.048 19.13,11.047L20.064,11.014C20.249,11.008 20.363,10.81 20.276,10.647L19.827,9.801C19.819,9.787 19.818,9.771 19.823,9.755C19.828,9.74 19.838,9.726 19.851,9.718L20.661,9.212C20.817,9.114 20.817,8.886 20.661,8.788L19.851,8.282C19.838,8.274 19.828,8.26 19.823,8.245C19.818,8.229 19.819,8.213 19.827,8.199L20.276,7.353C20.363,7.19 20.249,6.992 20.064,6.986L19.13,6.953C19.108,6.952 19.087,6.943 19.072,6.928C19.057,6.913 19.048,6.892 19.047,6.87L19.014,5.936C19.008,5.751 18.81,5.637 18.647,5.724L17.802,6.173C17.787,6.181 17.77,6.182 17.755,6.177C17.74,6.172 17.726,6.162 17.718,6.149L17.212,5.339Z"
                    style={{
                      fill: "var(--primary-15)",
                      fillRule: "nonzero",
                    }}
                  />
                  <circle cx="17" cy="9" r="2" style={{ fill: "white" }} />
                </g>
              </g>
            </svg>
          </div>
          <img
            onClick={() => {
              showDocumentModal(
                "photo",
                photoSlot?.image,
                photoSlot,
                results,
                refetch,
                photoSlot?.case_thumbnail
              );
            }}
            src={photoSlot.image}
            alt={`Case photo ${slotNumber}`}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "contain",
              objectPosition: "center",
              display: "block",
            }}
          />
        </div>
      );
    }

    return (
      <DefaultThumbnail
        {...defaultThumbnailProps}
        height={`${height}px`}
        width={`${width}px`}
        photoData={photoSlot}
        photoSlots={photoSlots}
        pageName={pageName}
        isPanel={isPanel}
        panelId={panelId}
        refetch={refetch}
      />
    );
  };

  return (
    <div
      className={`image-${slotNumber}`}
      style={{
        width: "155px",
        minWidth: "min-content",
        maxWidth: "255px",
        height: `${height}px`,
      }}
    >
      <div
        style={{
          height: `${height}px`,
        }}
        className="img-cover-block img-box d-flex align-items-center"
      >
        {renderImage()}
      </div>
    </div>
  );
};

const createCounselingFirmsData = (data, onInviteSent) => {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.map((firm, index) => ({
    id: `firm-${firm.id || index}`,
    label: <CoCounselFirmRow firm={firm} index={index} onInviteSent={onInviteSent} />,
    value: firm.id,
    type: "counseling_firm",
    firmData: firm,
  }));
};

const ClientAvatar = ({ client }) => {
  const hasName = client.firstName || client.lastName;

  if (!hasName && !client.profilePic) return null;

  return (
    <div className="d-flex align-items-center">
      {client.profilePic ? (
        <img
          src={client.profilePic}
          className="ic ic-avatar ic-19 has-avatar-icon has-cover-img m-r-5"
          alt={`${client.firstName} ${client.lastName}`.trim()}
        />
      ) : (
        <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img m-r-5">
          <img
            src={avatarImage}
            style={{
              background: "var(--primary-30)",
            }}
            className="ic ic-avatar ic-19 has-avatar-icon has-cover-img m-r-5"
            alt=""
          />
        </span>
        // <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img m-r-5" />
      )}
      {hasName && (
        <span className="font-weight-semibold">
          {[client.firstName, client.lastName].filter(Boolean).join(" ")}
        </span>
      )}
    </div>
  );
};

const ClientAge = ({ client }) => {
  if (client.isEmpty || !client.firstName || !client.age) return null;

  return (
    <span className="padding-left35">
      Age <span className="font-weight-semibold">{client.age}</span>
    </span>
  );
};

const createClientsData = (caseSummaryState) => {
  if (!caseSummaryState) return [];

  const processedClients = [];

  if (caseSummaryState.for_client) {
    const singleClient = {
      id: caseSummaryState.for_client.id,
      profilePic: caseSummaryState.for_client.profile_pic_19p,
      firstName: caseSummaryState.for_client.first_name,
      lastName: caseSummaryState.for_client.last_name,
      age: caseSummaryState?.for_client?.entity_name
        ? ""
        : calculateAge(caseSummaryState.for_client.birthday),
      isEmpty: false,
    };

    if (singleClient.firstName || singleClient.lastName) {
      processedClients.push(singleClient);
    }
  }

  if (caseSummaryState.multipleClient_for_case?.length > 0) {
    const multipleClients = caseSummaryState.multipleClient_for_case
      .map((clientWrapper) => ({
        id: clientWrapper.new_client.id,
        profilePic: clientWrapper.new_client.profile_pic_19p,
        firstName: clientWrapper.new_client.first_name,
        lastName: clientWrapper.new_client.last_name,
        age: clientWrapper?.new_client?.entity_name
          ? ""
          : calculateAge(clientWrapper.new_client.birthday),
        isEmpty: false,
      }))
      .filter((client) => client.firstName || client.lastName); // Only include clients with names

    processedClients.push(...multipleClients);
  }

  return processedClients.map((client, index) => ({
    id: `client-${client.id || index}`,
    label: <ClientAvatar client={client} />,
    value: <ClientAge client={client} />,
    type: "client",
    clientData: client,
  }));
};

const createStatuteLimitationsData = (caseSummaryState) => {
  const limitations = caseSummaryState || [];
  if (!Array.isArray(limitations) || limitations.length === 0) {
    return [];
  }
  return limitations
    .filter((item) => item?.start_date && item?.date_name)
    .map((caseItem, index) => ({
      id: `statute-${index}`,
      baseObj: caseItem,
      label: caseItem.date_name,
      value: formatDateWithAbbreviation(caseItem.start_date),
      rawDate: caseItem.start_date,
      type: "statute-limitation",
      eventTypeId: caseItem?.event_type_id,
      eventName: caseItem?.name,
    }))
    .sort((a, b) => new Date(a.rawDate) - new Date(b.rawDate));
};
const getLatestDisposition = (caseSummaryState) => {
  const dispositions = [
    { label: "Accepted:", value: formatCalendarDate(caseSummaryState.accepted_date) },
    { label: "Rejected:", value: formatCalendarDate(caseSummaryState.case_rejected) },
    { label: "Referred:", value: formatCalendarDate(caseSummaryState.case_referred) },
    { label: "Dropped:", value: formatCalendarDate(caseSummaryState.case_dropped) },
  ].filter((d) => d.value); // exclude nulls/undefined

  if (!dispositions.length) {
    return { label: "Accepted:", value: null };
  }

  return dispositions.reduce((latest, current) => {
    return new Date(current.value) > new Date(latest.value) ? current : latest;
  });
};

const createCaseSummaryData = (caseSummaryState) => {
  if (!caseSummaryState) return [];
  const disposition = getLatestDisposition(caseSummaryState); // 👈
  return [
    {
      id: "incident-date",
      label: (
        <span
          className="text-label font-weight-semibold d-flex align-items-center"
          style={STYLES.labelText}
        >
          <img
            src={incidentIcon}
            className="m-r-5"
            style={STYLES.incidentIcon}
            alt="Incident icon"
          />
          Incident Date
        </span>
      ),
      value: formatCalendarDate(caseSummaryState.incident_date),
      type: "date",
    },
    {
      id: "status-intake",
      label: renderStatusLabel(caseSummaryState.status, "Intake", caseSummaryState.date_closed),
      value: formatCalendarDate(caseSummaryState.intake_date),
      type: "status-date",
    },
    {
      id: "retained",
      label: "Retained:",
      value: formatCalendarDate(caseSummaryState.retained),
      type: "date",
    },
    {
      id: "disposition", // 👈 was "accepted"
      label: disposition.label, // 👈 dynamic
      value: disposition.value, // 👈 dynamic
      type: "date",
    },
    {
      id: "closed",
      label: "Closed:",
      value: formatCalendarDate(caseSummaryState.date_closed),
      type: "date",
    },
  ];
};

const NewCaseHourlyPage = () => {
  const dispatch = useDispatch();
  const { isValid } = useAccessValidation();
  const currentCaseId = getCaseId();
  const clientId = getClientId();

  const [editDetail, setEditDetail] = useState(null);
  const [litigationData, setLitigationData] = useState({});
  const [showActPopup, setShowActPopup] = useState(false);
  // const [eventTypesData, setEventTypesData] = useState([]);
  const [isBlocked, setIsBlocked] = useState(false);
  const { isLitigationActDataUpdated, setLitigationActDataUpdated } = useContext(ClientDataContext);

  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (currentCaseId && !pageObject) {
      fetchPageObject(currentCaseId, 79).then((data) => {
        setPageObject(data);
      });
    }
  }, [currentCaseId, pageObject]);

  useEffect(() => {
    const newClientID = location.pathname.split("/")[2];
    const newCaseID = location.pathname.split("/")[3];
    const clientID = getClientId();
    const caseID = getCaseId();

    if (newClientID !== clientID || newCaseID !== caseID) {
      setClientId(newClientID);
      setCaseId(newCaseID);
      dispatch(setCaseSummary(null));
      dispatch(setCurrentCase(null));
      dispatch(setClientProviders(null));
    }
  }, [location, dispatch]);

  const currentCase = useSelector((state) => state?.caseData?.current);
  const caseSummaryState = useSelector((state) => state?.caseData?.summary);
  const timelineEvents = useSelector((state) => state?.caseData?.summary?.timeline_events);
  const statueOfLimitation = useSelector((state) => state?.caseData?.caseStatuteLimitations);
  const client = useSelector((state) => state?.client?.current);
  const [counsellingOpen, setCounsellingOpen] = useState(false);
  const [addNewClientOnCaseOpen, setAddNewClientOnCase] = useState(false);
  const [isChangeFirmAddress, setIsChangeFirmAddress] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const {
    relationships: coCounselRelationships,
    error: coCounselError,
    refresh: refreshCoCounsel,
  } = useCoCounsel(clientId, currentCaseId);
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  const fetchCaseSummaryApi = useCallback(
    async (clientId, caseId) => {
      try {
        const response = await api_without_cancellation.get(
          `/api/cases/${clientId}/${caseId}/summary/`
        );
        dispatch(setCaseSummary(response.data));
      } catch (e) {
        console.error(e);
      }
    },
    [dispatch]
  );

  const fetchLitigationData = async () => {
    try {
      const litigation_data = await api_without_cancellation.get(
        `/api/litigation-page/litigation/?case_id=${currentCaseId}&client_id=${clientId}`
      );
      if (litigation_data.status === 200) {
        setLitigationData(litigation_data.data);
      }
    } catch (error) {
      console.error("Failed to fetch Litigation Data:", error);
    }
  };

  // const getEventType = useCallback(async () => {
  //   try {
  //     const response = await api_without_cancellation.get("/api/all/event/types/");
  //     setEventTypesData(response.data.data);
  //   } catch (err) {
  //     console.error("Error fetching Event Types:", err);
  //   }
  // }, [origin]);

  const fetchBlockedStatus = useCallback(async () => {
    try {
      const response = await api_without_cancellation.get(
        `/api/litigation-page/litigation-act-blocked-status/${clientId}/${currentCaseId}/`
      );
      if (response.status === 200) {
        setIsBlocked(response.data.blocked);
      }
    } catch (error) {
      console.error("Error fetching blocked status:", error);
    }
  }, [clientId, currentCaseId, origin]);

  useEffect(() => {
    const newClientID = location.pathname.split("/")[2] || getClientId();
    const newCaseID = location.pathname.split("/")[3] || getCaseId();

    // 1. Always fetch when this effect runs (mount, client change, URL change, or update flag)
    fetchLitigationData();
    fetchCaseSummaryApi(newClientID, newCaseID);
    fetchShakespeareStatus(newCaseID, 1, dispatch);

    // include everything that should deliberately trigger a fresh fetch
  }, [client, location.pathname]);

  useEffect(() => {
    if (isLitigationActDataUpdated && setLitigationActDataUpdated) {
      fetchCaseSummaryApi(clientId, currentCaseId);
    }
  }, [isLitigationActDataUpdated]);

  const memoizedDataForFirstTd = useMemo(
    () => createCaseSummaryData(caseSummaryState),
    [caseSummaryState]
  );

  const memoizedDataForSecondTD = useMemo(
    () => createStatuteLimitationsData(statueOfLimitation),
    [caseSummaryState]
  );

  const memoizedDataForThirdTD = useMemo(
    () => createClientsData(caseSummaryState),
    [caseSummaryState]
  );

  const handleClosePopup = useCallback(() => {
    if (showActPopup === true) {
      setShowActPopup(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showActPopup]);

  const [caseTypeModal, setCaseTypeModal] = useState(false);
  const panelConfig = {
    heading: "Open",
    // target: "#edit-case-dates-modal",
    data: memoizedDataForFirstTd,
    button: "Edit Case Type and Dates",
    leftHand: false,
    onClick: () => {
      //   console.log("Panel button clicked");
      // Additional logic if needed
      setCaseTypeModal(true);
    },
    clickId: 999,
  };
  const statueConfig = {
    heading: "Statute of Limitations",
    target: "",
    data: memoizedDataForSecondTD,
    button: "Statute of Limitations Deadline",
    leftHand: true,
    onClick: () => setShowActPopup(true),
    click: (baseObj) => setEditDetail(baseObj),
    clickId: 999,
  };
  const clientConfig = {
    heading: "Clients on Case",
    // target: "addCase",
    data: memoizedDataForThirdTD,
    button: "New Client on Case",
    leftHand: true,
    onClick: () => setAddNewClientOnCase(true),
    click: () => {},
    clickId: 999,
  };

  useEffect(() => {
    setCounsellingOpen(false);
  }, [clientId, currentCaseId]);
  const refreshCoCounselCase = useCallback(async () => {
    await Promise.all([refreshCoCounsel(), fetchCaseSummaryApi(clientId, currentCaseId)]);
  }, [refreshCoCounsel, fetchCaseSummaryApi, clientId, currentCaseId]);
  const counselingFirmsData = useMemo(
    () => createCounselingFirmsData(coCounselRelationships, refreshCoCounselCase),
    [coCounselRelationships, refreshCoCounselCase]
  );
  const counselingFirmsConfig = {
    heading: "CO-COUNSELlING FIRMS",
    data: counselingFirmsData,
    button: "CoCounseling Firm",
    leftHand: true,
    onClick: () => setCounsellingOpen(true),
    clickId: 999,
  };

  const [currentPage, setCurrentPage] = useState("home");
  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  const mainTabs = useMemo(() => {
    const tabs = [];
    //
    tabs.push({
      id: "home",
      label: "Home",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("home"),
      leftHand: false,
    });

    tabs.push({
      id: "summary-case-page",
      label: "Summary",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("summary-case-page"),
      leftHand: false,
    });

    return tabs;
  }, [handlePageChange]);

  const buttonTabs = useMemo(() => {
    const tabs = [];

    // Expert add button with gold icon
    // tabs.push({
    //   id: "new-client-on-case",
    //   label: "New Client on Case",
    //   className: "tab-trapezium-cycles-corners",
    //   background: "var(--primary-60)",
    //   left: "0px",
    //   onClick: () => setAddNewClientOnCase(true),
    //   leftHand: true,
    //   span: (
    //     <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
    //       <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
    //     </span>
    //   ),
    // });

    // tabs.push({
    //   id: "new-co-counseling-firm",
    //   label: "CoCounseling Firm",
    //   className: "tab-trapezium-cycles-corners",
    //   background: "var(--primary-60)",
    //   left: "0px",
    //   onClick: () => setCounsellingOpen(true),
    //   leftHand: true,
    //   span: (
    //     <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
    //       <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
    //     </span>
    //   ),
    // });

    return tabs;
  }, []);

  const photoTabs = useMemo(
    () => [
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
    ],
    []
  );
  const attachmentTabs = usePageAttachmentTabs(79, photoTabs);

  const caseTimelineRef = useRef(null);
  const containerRef = useRef(null);
  const secondRef = useRef(null);

  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(440);
  // useEffect(() => {
  //   const calculateRows = () => {
  //     // if (timelineEvents.length === 0) {
  //     //   //   setRowCount(0);
  //     //   return;
  //     // }

  //     const leftSideEl1 = containerRef.current?.offsetHeight || 0;
  //     const leftSideEl2 = secondRef.current?.offsetHeight || 0;
  //     setHeight(leftSideEl1);
  //     const availableHeight = leftSideEl1 - 25;
  //     // const availableHeight = mainHeight - 25;
  //     const rows = Math.floor(availableHeight / 21);
  //     let addRows;

  //     const data = timelineEvents?.length * 2;
  //     const finalRows = rows - data;

  //     setRowCount(finalRows);
  //   };

  //   calculateRows();

  //   window.addEventListener("resize", calculateRows);

  //   return () => {
  //     window.removeEventListener("resize", calculateRows);
  //   };
  // }, [containerRef, secondRef, timelineEvents, client_providers]);
  const [shouldScroll, setShouldScroll] = useState(false);

  useEffect(() => {
    const calculateRows = () => {
      const leftSideEl1 = containerRef.current?.offsetHeight || 0;
      setHeight(leftSideEl1);
      const availableHeight = leftSideEl1 - 25; // Subtract header height

      // Count actual rendered rows: 1 date heading per date, plus each event's
      // client rows (one per for_clients entry) and its single event line.
      const eventRowsCount = (timelineEvents || []).reduce((total, temp) => {
        const perDate = (temp.events || []).reduce((sum, x) => {
          const clientRows =
            x.type === "Litigation" || x.type === "SOL" ? (x?.event?.for_clients || []).length : 0;
          return sum + clientRows + 1; // client rows + event line
        }, 0);
        return total + 1 + perDate; // date heading + this date's event rows
      }, 0);
      const eventRowsHeight = eventRowsCount * 21;

      // Check if content overflows
      if (eventRowsHeight > availableHeight) {
        // Content overflows - enable scrolling
        setShouldScroll(true);
        setRowCount(0); // No fake rows needed
      } else {
        // Content fits - disable scrolling and fill remaining space
        setShouldScroll(false);
        const remainingHeight = availableHeight - eventRowsHeight;
        const fullRows = Math.floor(remainingHeight / 21);
        const partialRowHeight = remainingHeight % 21;

        setRowCount(partialRowHeight > 0 ? fullRows + 1 : fullRows);
      }
    };

    calculateRows();
    window.addEventListener("resize", calculateRows);
    return () => window.removeEventListener("resize", calculateRows);
  }, [containerRef, secondRef, timelineEvents]);

  const [firmName, setFirmName] = useState();

  useEffect(() => {
    async function fetchFirmName() {
      try {
        const response = await api_without_cancellation.get(
          `/api/cases/${getClientId()}/${getCaseId()}/summary/`
        );

        setFirmName(response?.data);
      } catch (error) {
        console.error("Error fetching firm name:", error);
      }
    }

    fetchFirmName();
  }, [getClientId(), getCaseId()]);
  const { selectedRoleIds, loading, error, refetch } = useTelephonySettings();

  const isSOLEventType = (eventTypeName) =>
    eventTypeName === "Statute of Limitations" ||
    eventTypeName === "Statute Of Limitations" ||
    eventTypeName === "S.O.L";

  // Icon shown before a timeline event name (Litigation -> event_type icon, SOL -> SOL icon)
  const renderTimelineEventIcon = (x) => {
    if (x.type === "SOL") {
      return (
        <span
          className="d-inline-flex align-items-center justify-content-center ic ic-15 m-r-5"
          style={{ flexShrink: 0 }}
        >
          <img src={SOLicon} className="ic-15" alt="" />
        </span>
      );
    }
    const eventTypeName = x?.event?.event_type_id?.litigation_event_type;
    if (isSOLEventType(eventTypeName)) {
      return (
        <span
          className="d-inline-flex align-items-center justify-content-center ic ic-15 m-r-5"
          style={{ flexShrink: 0 }}
        >
          <img src={SOLicon} className="ic-15" alt="" />
        </span>
      );
    }
    if (eventTypeName === "Expert Discovery") {
      return (
        <span
          className="d-inline-flex align-items-center justify-content-center ic ic-15 m-r-5"
          style={{ flexShrink: 0 }}
        >
          <img src={ExpertDiscovery} className="ic-15" alt="" />
        </span>
      );
    }
    return (
      <i
        className={`ic ic-15 ${EVENT_TYPE_ICONS[eventTypeName] || "ic-Event"} m-r-5`}
        style={{ flexShrink: 0 }}
      />
    );
  };

  // One row per client on the event, each with the client icon
  const renderTimelineClientRows = (x) =>
    (x?.event?.for_clients || []).map((client) => (
      <div
        key={`tl-client-${x.id}-${client?.id}`}
        className="d-flex align-items-center"
        style={{ height: "21px" }}
      >
        <i className="ic ic-15 ic-client m-r-5" />
        <span
          style={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            fontWeight: "600",
          }}
        >
          {client?.first_name} {client?.last_name}
        </span>
      </div>
    ));

  if (!isValid) {
    return null; // or a loading spinner, or redirect to login
  }

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="79" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            <SmartResponsiveTabsContainer
              HandlePage={currentPage}
              tabsData={mainTabs}
              viewTab={[]}
              addTab={buttonTabs}
              photoTab={attachmentTabs}
              handlePageChange={handlePageChange}
              viewType={""}
            />
            <div
              style={{
                width: "100%",
                justifyContent: "flex-start",
                background: "var(--primary)",
                height: "25px",
                marginBottom: "5px",
              }}
            >
              <span
                className="fw-bold text-white"
                style={{
                  height: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {currentPage === "home"
                  ? "Case Hourly Home"
                  : currentPage === "summary-case-page"
                    ? "Case Hourly Summary"
                    : ""}
              </span>
            </div>
            {/* New Case Page Content Goes Here */}
            {currentPage === "home" && (
              <>
                <div
                  className="d-flex"
                  style={{
                    gap: "5px",
                  }}
                >
                  <div
                    className="d-flex flex-column m-b-5"
                    style={{
                      flex: "1 1 0",
                      minWidth: 0,
                      gap: "5px",
                      width: "calc(100% - 188px - 5px)",
                      maxHeight: "max-content",
                    }}
                    ref={containerRef}
                  >
                    <div className="d-flex flex-column w-100">
                      <div className="menu-bar-style d-flex align-items-center ">Matter</div>
                      <div className="bg-primary-2 height-25 d-flex align-items-center justify-content-between p-l-5 p-r-5">
                        <div className="d-flex align-items-center">
                          <span className="m-r-5 d-flex align-items-center">
                            <img src={fileNumberIcon} style={{ width: 15, height: 15 }} alt="" />
                          </span>
                          <span>{currentCase?.file_number}</span>
                        </div>

                        <span>{formatDateAtTime(currentCase?.date_open)}</span>
                      </div>
                    </div>
                    <div
                      className="d-flex flex-wrap align-items-center mb-0"
                      style={{
                        gap: "5px",
                      }}
                    >
                      {caseSummaryState?.processed_photo_slots?.length > 0 && (
                        <div className="d-none-on-1280px">
                          {caseSummaryState?.processed_photo_slots
                            ?.slice(0, 1)
                            ?.map((photoSlot, index) => {
                              if (!photoSlot?.photo) {
                                return (
                                  <DefaultThumbnail
                                    key={`empty-${index}`}
                                    {...defaultThumbnailProps}
                                    photoData={photoSlot}
                                    photoSlots={caseSummaryState?.processed_photo_slots}
                                    pageName={pageObject?.name || "Case"}
                                    refetch={() => fetchCaseSummaryApi(getClientId(), getCaseId())}
                                  />
                                );
                              }

                              return (
                                <PhotoSlot
                                  key={photoSlot.photo?.photo_slot.slot_number}
                                  photoSlot={photoSlot?.photo}
                                  photoSlots={caseSummaryState?.processed_photo_slots}
                                  pageName={pageObject?.name || "Case"}
                                  slotNumber={photoSlot.photo_slot.slot_number}
                                  refetch={() => fetchCaseSummaryApi(getClientId(), getCaseId())}
                                />
                              );
                            })}
                        </div>
                      )}
                      <NewCasePanels
                        panel_name={panelConfig.heading}
                        data={panelConfig.data}
                        hasBtn={true}
                        buttonText={panelConfig.button}
                        onClick={panelConfig.onClick}
                        target={panelConfig.target}
                        panelClassName="min-w-260px-client"
                        clickId={panelConfig.clickId}
                        colorGiven={"var(--primary-25)"}
                      />

                      <NewCasePanels
                        panel_name={statueConfig.heading}
                        data={statueConfig.data}
                        hasBtn={true}
                        buttonText={statueConfig.button}
                        onClick={statueConfig.onClick}
                        click={statueConfig.click}
                        // target={statueConfig.target}
                        leftHand={statueConfig.leftHand}
                        panelClassName="flex-panels-1"
                        clickId={statueConfig.clickId}
                      />
                      <NewCasePanels
                        panel_name={clientConfig.heading}
                        data={clientConfig.data}
                        hasBtn={true}
                        buttonText={clientConfig.button}
                        onClick={clientConfig.onClick}
                        // target={statueConfig.target}
                        leftHand={clientConfig.leftHand}
                        panelClassName="flex-panels-1"
                        isLastPanel={true}
                        clickId={statueConfig.clickId}
                      />
                    </div>
                    <div
                      className="d-flex flex-wrap align-items-center mb-0"
                      style={{
                        gap: "5px",
                      }}
                      // ref={secondRef}
                    >
                      {caseSummaryState?.processed_photo_slots && (
                        <div className="d-block-on-1280px">
                          {caseSummaryState?.processed_photo_slots
                            ?.slice(0, 1)
                            ?.map((photoSlot, index) => {
                              if (!photoSlot?.photo) {
                                return (
                                  <DefaultThumbnail
                                    key={`empty-${index}`}
                                    {...defaultThumbnailProps}
                                    photoData={photoSlot}
                                    photoSlots={caseSummaryState?.processed_photo_slots}
                                    pageName={pageObject?.name || "Case"}
                                    refetch={() => fetchCaseSummaryApi(getClientId(), getCaseId())}
                                  />
                                );
                              }

                              return (
                                <PhotoSlot
                                  key={photoSlot.photo?.photo_slot.slot_number}
                                  photoSlot={photoSlot?.photo}
                                  photoSlots={caseSummaryState?.processed_photo_slots}
                                  pageName={pageObject?.name || "Case"}
                                  slotNumber={photoSlot.photo?.photo_slot.slot_number}
                                  refetch={() => fetchCaseSummaryApi(getClientId(), getCaseId())}
                                />
                              );
                            })}
                        </div>
                      )}
                      <>
                        {caseSummaryState?.processed_photo_slots
                          ?.slice(1, 2)
                          ?.map((photoSlot, index) => {
                            if (!photoSlot?.photo) {
                              return (
                                <DefaultThumbnail
                                  key={`empty-${index}`}
                                  {...defaultThumbnailProps}
                                  photoData={photoSlot}
                                  photoSlots={caseSummaryState?.processed_photo_slots}
                                  pageName={pageObject?.name || "Case"}
                                  refetch={() => fetchCaseSummaryApi(getClientId(), getCaseId())}
                                />
                              );
                            }

                            return (
                              <PhotoSlot
                                key={photoSlot.photo?.photo_slot.slot_number}
                                photoSlot={photoSlot?.photo}
                                photoSlots={caseSummaryState?.processed_photo_slots}
                                pageName={pageObject?.name || "Case"}
                                slotNumber={photoSlot.photo?.photo_slot.slot_number}
                                refetch={() => fetchCaseSummaryApi(getClientId(), getCaseId())}
                              />
                            );
                          })}
                      </>
                      <CasePageContactPanel
                        id={currentCase?.id}
                        panel_name="Case Home Office"
                        className="pe-0 min-w-260px-client"
                        title={""}
                        isCaseHomeOffice={true}
                        name={currentCase?.for_client?.created_by?.office_name}
                        address1={currentCase?.firm_addresses?.address1}
                        nickName={currentCase?.firm_addresses?.nickname}
                        address2={currentCase?.firm_addresses?.address2}
                        city={currentCase?.firm_addresses?.city}
                        websiteURL={currentCase?.firm_addresses?.website}
                        state={currentCase?.firm_addresses?.state}
                        zip_code={currentCase?.firm_addresses?.zip}
                        phone_number={currentCase?.firm_addresses?.phone_number}
                        ext={currentCase?.firm_addresses?.phone_ext ?? ""}
                        fax_number={currentCase?.firm_addresses?.fax}
                        onSelectObject={() => {
                          addClickRecord(999, 1);
                          setIsChangeFirmAddress(true);
                          setSelectedLocationId(currentCase?.firm_addresses?.id ?? null);
                        }}
                        buttonData={[
                          {
                            iconClassName: "",
                            buttonText: "Assign Case Home Office",
                            className: "p-l-6 p-r-5",
                            style: { height: "25px", width: "100%" },
                            onClick: () => {
                              addClickRecord(999, 1);
                              setIsChangeFirmAddress(true);
                              setSelectedLocationId(currentCase?.firm_addresses?.id ?? null);
                            },
                          },
                        ]}
                        // className="max-panel-width-case-page"
                      />

                      {coCounselError && (
                        <div className="alert alert-danger p-1 mb-1" role="alert">
                          {coCounselError}{" "}
                          <button
                            type="button"
                            className="btn btn-link p-0"
                            onClick={refreshCoCounsel}
                          >
                            Retry
                          </button>
                        </div>
                      )}
                      <NewCasePanels
                        panel_name={counselingFirmsConfig.heading}
                        data={counselingFirmsConfig.data}
                        hasBtn={true}
                        buttonText={counselingFirmsConfig.button}
                        onClick={counselingFirmsConfig.onClick}
                        // target={statueConfig.target}
                        leftHand={counselingFirmsConfig.leftHand}
                        panelClassName="flex-panels-1 min-co-counselling"
                        panelClassSpan="w-100"
                      />
                    </div>
                  </div>
                  <div
                    className=" m-b-5"
                    style={{
                      width: "188px",
                      flex: "0 0 188px",
                      // background: "red",
                      // height: "100%",
                      overflowY: shouldScroll ? "scroll" : "hidden",
                      scrollbarWidth: "none",
                      marginTop: "0px",
                      maxHeight: `${height}px`,
                    }}
                    ref={caseTimelineRef}
                  >
                    <div
                      className="menu-bar-style client-contact-title text-center d-flex justify-content-center align-items-center"
                      style={{
                        height: "25px",
                        // backgroundColor: "var(--primary-15)",
                        position: "sticky",
                        top: "0px",
                      }}
                    >
                      Case Timeline
                    </div>
                    {timelineEvents?.map((temp) => (
                      <>
                        <div
                          key={temp.id}
                          className="d-flex justify-content-center task"
                          style={{ padding: "0px 5px", height: "21px", color: "var(--primary)" }}
                        >
                          <div>
                            <strong>
                              {courtWeekday(temp.date)}, {formatCourtDate(temp.date, "calendar")}
                            </strong>{" "}
                          </div>
                          {/* <div>
                        <strong>
                         
                        </strong>
                      </div> */}
                        </div>
                        <div
                          key={temp.id + "_events"}
                          className="task d-block"
                          style={{ padding: "0px 5px", minHeight: "21px" }}
                        >
                          {temp.events &&
                            temp.events?.map((x) => (
                              <React.Fragment key={x.id}>
                                {x.type === "Litigation" || x.type === "SOL" ? (
                                  <>
                                    {renderTimelineClientRows(x)}
                                    <div className="d-flex justify-content-between">
                                      <span
                                        style={{
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                          overflow: "hidden",
                                        }}
                                      >
                                        {x.event.is_allday
                                          ? "all-day"
                                          : formatCourtTime(
                                              getActTime(
                                                x.event,
                                                x.type === "SOL"
                                                  ? "end_date"
                                                  : getActEndpoint(x.event)
                                              ),
                                              true
                                            )}
                                      </span>
                                      <span
                                        style={{
                                          maxWidth: x.event.is_allday ? "120px" : "110px",
                                          minWidth: 0,
                                        }}
                                        className="d-flex align-items-center justify-content-end"
                                      >
                                        {renderTimelineEventIcon(x)}
                                        <span
                                          style={{
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            minWidth: 0,
                                          }}
                                        >
                                          {x?.event?.name}
                                        </span>
                                      </span>
                                    </div>
                                  </>
                                ) : (
                                  x.type === "TreatmentDates" && (
                                    <div className="d-flex justify-content-between">
                                      <div
                                        className="d-flex align-items-center justify-content-center text-center text-white specialty-icon"
                                        style={{
                                          backgroundColor: x.event.specialty?.color,
                                          height: "21px",
                                          width: "21px",
                                        }}
                                      >
                                        {x?.event?.specialty?.name[0]}
                                      </div>
                                      <span
                                        style={{
                                          maxWidth: "140px",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          fontWeight: "600",
                                        }}
                                        className="text-end d-block full-width"
                                      >
                                        {x?.event?.name}
                                      </span>
                                    </div>
                                  )
                                )}
                              </React.Fragment>
                            ))}
                        </div>
                      </>
                    ))}
                    {Array.from({ length: rowCount }, (_, index) => (
                      <div
                        key={`fake-row-${rowCount + index}`}
                        className="fake-new-case-page-row"
                        style={{ height: "21px" }}
                      >
                        {/*  */}
                      </div>
                    ))}
                  </div>
                </div>

                <WorkersOnCase selectedRoleIds={selectedRoleIds} />
                {/* <div className="mx-auto documents-wrapper" style={{ marginRight: "0px" }}>
                  <div className="col-12 ps-0 pe-0">
                    <DocumentRow
                      clientProvider={currentCaseId}
                      pageName={pageObject?.name}
                      page_id={1}
                      showESignatures
                    />
                  </div>
                </div> */}
                <div className="d-flex documents-wrapper" style={{ marginRight: "0px" }}>
                  <div className="col-12 pe-0">
                    <ClientDocumentRow
                      clientProvider={currentCaseId}
                      pageName={pageObject?.name}
                      page_id={79}
                    />
                  </div>
                </div>
              </>
            )}

            {currentPage === "photo" && (
              <>
                <PhotoTab pageId={79} pageName={"CaseHourly"} />
              </>
            )}
            <NotesSectionDashboard pageName={"CaseHourly"} />
          </div>
        </div>
      </div>

      <Footer />

      {addNewClientOnCaseOpen && (
        <AddNewClientModal setOpen={setAddNewClientOnCase} open={addNewClientOnCaseOpen} />
      )}

      {caseTypeModal && (
        <>
          <EditCaseTypeDateModal show={caseTypeModal} handleClose={() => setCaseTypeModal(false)} />
        </>
      )}

      {isChangeFirmAddress && (
        <ChangeOfficeFirmLocationModal
          selectedLocationId2={selectedLocationId}
          showModal={isChangeFirmAddress}
          handleClose={() => {
            addClickRecord(999, 1);
            setIsChangeFirmAddress(false);
          }}
        />
      )}

      {counsellingOpen && (
        <CounsellingModal
          setOpen={setCounsellingOpen}
          open={counsellingOpen}
          close={() => {
            addClickRecord(999, 1);
            setCounsellingOpen(false);
          }}
          refetch={refreshCoCounselCase}
          clientId={clientId}
          caseId={currentCaseId}
        />
      )}
      {editDetail && (
        <EditSOLPopup
          showPopup={editDetail}
          handleClose={() => setEditDetail(null)}
          litigationDetail={litigationData?.litigation}
          act={editDetail}
        />
      )}
      {showActPopup && (
        <SOLActPopupCasePage
          showPopup={showActPopup}
          handleClose={handleClosePopup}
          litigationDetail={litigationData?.litigation}
          isBlocked={isBlocked}
          refetch={() => fetchCaseSummaryApi(clientId, currentCaseId)}
        />
      )}
    </>
  );
};

export default NewCaseHourlyPage;
